// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Belt_Option from "../../../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Router from "next/router";
import * as AuthStore$PorterinFeature from "../../../../domain/store/AuthStore.mjs";
import * as AuthTextCmp$PorterinFeature from "../../common/AuthTextCmp.mjs";
import * as LoginTncCmp$PorterinFeature from "../../login/LoginTncCmp.mjs";
import * as AuthHeaderCmpV2$PorterinFeature from "../../common/AuthHeaderCmpV2.mjs";
import * as SignupFormCmpV2$PorterinFeature from "./form/SignupFormCmpV2.mjs";
import * as SignupPictureCmp$PorterinFeature from "./SignupPictureCmp.mjs";
import * as CategoryAnalytics$PorterinFeature from "../../../../../fare-estimate-v1/domain/helpers/CategoryAnalytics.mjs";
import * as CommonAnalyticsHelper$PorterinFeature from "../../../../../../shared/core/helpers/CommonAnalyticsHelper.mjs";
import * as AuthWrapperModuleScss from "../../../styles/AuthWrapper.module.scss";
import * as FareEstimateAnalyticsHelper$PorterinFeature from "../../../../../fare-estimate-v1/domain/helpers/FareEstimateAnalyticsHelper.mjs";

var styles = AuthWrapperModuleScss;

function SignupCmpV2(Props) {
  var set_auth_state = Props.set_auth_state;
  var close_modal = Props.close_modal;
  var prefill = Props.prefill;
  var router = Router.useRouter();
  var mobile = prefill !== undefined ? Belt_Option.getWithDefault(prefill.mobile, "") : "";
  React.useEffect((function () {
          var timeout_id = setTimeout((function (param) {
                  CommonAnalyticsHelper$PorterinFeature.publishPageLandEventWithParameter(CategoryAnalytics$PorterinFeature.getCategoryName(router), AuthStore$PorterinFeature.Signup.ga_page_landing, AuthStore$PorterinFeature.Signup.moe_page_landing_parameter, FareEstimateAnalyticsHelper$PorterinFeature.getFareSelectedCardVersionEventPayload(mobile));
                }), 0);
          return (function (param) {
                    clearTimeout(timeout_id);
                  });
        }), []);
  return React.createElement("div", {
              className: styles.wrapper
            }, React.createElement(AuthHeaderCmpV2$PorterinFeature.make, {
                  close_modal: close_modal
                }), React.createElement(SignupPictureCmp$PorterinFeature.make, {}), React.createElement(AuthTextCmp$PorterinFeature.make, {
                  heading: AuthStore$PorterinFeature.Login.modal_heading,
                  sub_heading: AuthStore$PorterinFeature.LoginV2.modal_subheading
                }), React.createElement(SignupFormCmpV2$PorterinFeature.make, {
                  set_auth_state: set_auth_state,
                  prefill: prefill
                }), React.createElement(LoginTncCmp$PorterinFeature.make, {}));
}

var make = SignupCmpV2;

export {
  styles ,
  make ,
}
/* styles Not a pure module */
